export function initStep0Data(productType, productCode, productName) {
    return {
        productType: productType,
        productCode: productCode,
        productName: productName
    }
}

export function initStep1Data(
    occupation,
    occupationId,
    position,
    positionId,
    salary,
    company,
    refName,
    refPhone,
    relationship,
    note
) {
    return {
        occupation: occupation,
        occupationId: occupationId,
        position: position,
        positionId: positionId,
        salary: salary,
        company: company,
        refName: refName,
        refPhone: refPhone,
        relationship: relationship,
        refNote: note,
        isSalaryError: false,
        isCompanyError: false,
        isRefPhoneError: false,
        isRefNameError: false,
    }
}

export function initStep2Data() {
    return {
        isAgree: false
    }
}
